export default __webpack_public_path__ + "static/media/misc-pantry3-1024w.004c3f51.webp";